var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('PageHero'),_c('div',{staticClass:"container my-12"},[_c('SectionPromoMobileApp')],1),_c('SectionEducation'),_c('SectionObesity'),_c('SectionDownloads')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }